import { createSlice } from "@reduxjs/toolkit";

import { logout } from "./login.reducer";

const initialState = {
  loading: false,
  notifications: [],
  unreadCount: 0,
  pagination: {
    total: 0,
    limit: 50,
    offset: 0,
    hasMore: false,
  },
};

const wipNotificationSlice = createSlice({
  name: "wipNotification",
  initialState,
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getWipNotifications: () => {},
    setWipNotifications: (state, action) => {
      const { notifications, pagination } = action.payload;
      state.notifications = notifications || [];
      if (pagination) {
        state.pagination = { ...state.pagination, ...pagination };
      }
    },
    getWipNotificationCount: () => {},
    setWipNotificationCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    triggerMarkWipNotificationAsRead: () => {},
    markWipNotificationAsRead: (state, action) => {
      state.notifications = state.notifications.map((notification) => {
        if (notification._id.toString() === action.payload._id.toString()) {
          return {
            ...notification,
            isRead: true,
            readAt: action.payload.readAt,
          };
        }
        return notification;
      });
      if (state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },
    triggerMarkAllWipNotificationsAsRead: () => {},
    markAllWipNotificationsAsRead: (state) => {
      state.notifications = state.notifications.map((notification) => ({
        ...notification,
        isRead: true,
      }));
      state.unreadCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const {
  loading,
  getWipNotifications,
  setWipNotifications,
  getWipNotificationCount,
  setWipNotificationCount,
  triggerMarkWipNotificationAsRead,
  markWipNotificationAsRead,
  triggerMarkAllWipNotificationsAsRead,
  markAllWipNotificationsAsRead,
} = wipNotificationSlice.actions;

export default wipNotificationSlice.reducer;

